import React, { useEffect, useState } from "react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "../../axios-backend";
import classes from "../../components/home/css/Home.module.css";
import "../home/products/css/ProductDetails.css";
import BackButton from "../main/BackButton";
import Line from "../main/Line";
import SwiperSlider from "../main/SwiperSlider";
import { InfiniteScrollList } from "./InfiniteScroll";
import { LazyImageWithLoader } from "./LazyImageWithLoader";

let cachedData = null;
let cachedProductIds = null;

const Women = () => {
  const [types, setTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [productId, setProductId] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const fetchData = async () => {
    if (cachedData && cachedProductIds) {
      setTypes(cachedData);
      setProductId(cachedProductIds);
      setIsLoading(false);
      return;
    }
    try {
      const response = await axios.get("/getTypeByGender", {
        params: { gender: 0 },
      });
      const data = response.data;
      if (data) {
        setTypes(data.types);
        cachedData = data.types;

        const singlecollections = [];
        for (let i = 0; i < data?.types?.length; i++) {
          const collection = data?.types;
          if (collection[i].singlecollection) singlecollections.push(collection[i]);
        }

        const newProductId = {};
        await Promise.all(
          singlecollections.map(async (each) => {
            const response = await axios.get(`/has-single-product`, {
              params: { id: each.id },
            });
            if (response.data.status === 200 && response.data.products.length) {
              newProductId[response?.data?.products[0]?.typeId] =
                response?.data?.products[0]?.id;
            }
          })
        );
        setProductId(newProductId);
        cachedProductIds = newProductId;
      }
    } catch (error) {
      // ignore errors silently
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      const scrollPosition = sessionStorage.getItem("scrollPositionWomen");
      if (scrollPosition) {
        setTimeout(() => {
          window.scrollTo(0, parseInt(scrollPosition));
        }, 50);
      }
    }
  }, [isLoading]);

  useEffect(() => {
    let timeoutId;
    const handleScroll = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const currentScrollPosition = window.pageYOffset;
        sessionStorage.setItem("scrollPositionWomen", currentScrollPosition);
      }, 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <>
      <BackButton location={location} />
      <Line type="bottom-line">
        <NavLink to="/world/membership" className={classes.navLink}>
          wonwonleywon membership
        </NavLink>
      </Line>
      {isLoading ? (
        <Line type="bottom-line" style={{ justifyContent: "center" }}>
          loading...
        </Line>
      ) : (
        <InfiniteScrollList
          allItems={types}
          itemsPerLoad={3}
          loadImages={(item) => {
            let images = [];
            try {
              if (item.womenproductimage && item.womenproductimage !== "undefined") {
                images = JSON.parse(item.womenproductimage);
              }
              images.forEach((src) => {
                const img = new Image();
                img.src = src.startsWith("s3")
                  ? `https://wonwonleywon-images.s3.amazonaws.com/collection_images/${src}`
                  : `${process.env.REACT_APP_Url}${src}`;
              });
            } catch (error) {
              // ignore
            }
          }}
          renderItem={(e, index) => {
            let images = [];
            try {
              if (e.womenproductimage && e.womenproductimage !== "undefined") {
                images = JSON.parse(e.womenproductimage);
              }
            } catch (error) {
              images = [];
            }
            return (
              <div key={index}>
                {images?.length > 0 && (
                  <>
                    <div
                      style={{
                        minHeight: "300px",
                        maxHeight: "100%",
                        height: "fit-content",
                        paddingTop: "20px",
                        paddingBottom: "20px",
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className="singleContainer"
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <SwiperSlider>
                          {images.map((i, idx) => {
                            const src = i.startsWith("s3")
                              ? `https://wonwonleywon-images.s3.amazonaws.com/collection_images/${i}`
                              : `${process.env.REACT_APP_Url}${i}`;

                            const handleClick = () => {
                              navigate(
                                `/products/${e.singlecollection ? "productdetails" : "productrelated"}`,
                                {
                                  state: {
                                    type: e.id,
                                    gender: 0,
                                    areaAmount: e.areaAmount,
                                    productId: e.singlecollection
                                      ? productId[e.id]
                                      : undefined,
                                    singleProduct: e.singlecollection,
                                  },
                                }
                              );
                            };

                            return (
                              <div
                                key={`${e.id}-${idx}`}
                                 onClick={(e) => {
  const swiper = e.target.closest(".swiper")?.swiper; 
  if (swiper && swiper.zoom && swiper.zoom.scale > 1.01) {
    // currently zoomed → block navigation
    return;
  }
  handleClick();
}}
                                style={{ cursor: "pointer" }}
                              >
                                <LazyImageWithLoader
                                  src={src}
                                  alt={`Product ${idx}`}
                                  style={{
                                    minHeight: "300px",
                                    maxHeight: "500px",
                                    minWidth: "300px",
                                    maxWidth: "500px",
                                    padding: "10px 0",
                                  }}
                                />
                              </div>
                            );
                          })}
                        </SwiperSlider>
                      </div>
                    </div>
                    <Line
                      type="bottom-line"
                      style={{
                        padding: "1.5rem 1rem",
                        height: "fit-content",
                        maxHeight: "100%",
                        lineHeight: "1.45rem",
                      }}
                    >
                      <NavLink
                        to={`/products/${e.singlecollection ? "productdetails" : "productrelated"}`}
                        state={{
                          type: e.id,
                          gender: 0,
                          areaAmount: e.areaAmount,
                          productId: e.singlecollection
                            ? productId[e.id]
                            : undefined,
                          singleProduct: e.singlecollection,
                        }}
                        className={classes.navLink}
                      >
                        {e.label ? e.label : e.name}
                      </NavLink>
                    </Line>
                  </>
                )}
              </div>
            );
          }}
        />
      )}
    </>
  );
};

export default Women;
